import React from "react";
import { ArrowRightIcon, ChevronDownIcon, PhoneIcon } from "lucide-react";
import { firm, navGroups, RESULTS_PATH } from "../../data/site";
import { actionClass } from "../../utils/actionStyles";
import { SiteLink } from "../SiteLink";
type MobileMenuProps = {
  id: string;
  onNavigate: () => void;
};
export function MobileMenu({
  id,
  onNavigate
}: MobileMenuProps) {
  return <div id={id} className="mobile-menu absolute inset-x-0 top-full overflow-y-auto overscroll-contain border-t border-line bg-white shadow-lg nav:hidden" data-id="element-116" data-mp="15k0lgrm9e6s1">
      <nav aria-label="Main" className="page-container py-3" data-id="element-117" data-mp="19k0zwc9cyhz3">
        <SiteLink path={RESULTS_PATH} onClick={onNavigate} className="mobile-results-link" data-id="element-118" data-mp="vnntby6d40ze">Results <ArrowRightIcon aria-hidden="true" size={22} data-id="element-119" data-mp="10miaywslfjhx" /></SiteLink>
        <div className="divide-y divide-line border-y border-line" data-id="element-120" data-mp="2q0n33ao2a0yr">
          {navGroups.map(group => <details key={group.id} className="group" data-id="element-121" data-mp="2v0020ts7iyhp">
              <summary className="flex min-h-[60px] cursor-pointer list-none items-center justify-between gap-4 py-4 text-label font-bold text-ink [&::-webkit-details-marker]:hidden" data-id="element-122" data-mp="2uxdugu5bgizh">
                <span data-id="element-123" data-mp="ya4j14cya2p7">{group.label}</span>
                <ChevronDownIcon aria-hidden="true" className="h-5 w-5 shrink-0 group-open:rotate-180" data-id="element-124" data-mp="1c1swbayxqx7r" />
              </summary>
              <ul className="divide-y divide-line border-t border-line pl-3" data-id="element-125" data-mp="181iduytyiec0">
                {group.id !== "cases" && <li data-id="element-126" data-mp="kbwjqpsfypav"><SiteLink path={RESULTS_PATH} onClick={onNavigate} className="nav-panel-results" data-id="element-127" data-mp="kbo26kldivtc">Results <ArrowRightIcon aria-hidden="true" size={20} data-id="element-128" data-mp="fctmvsmm7pdz" /></SiteLink></li>}
                {group.links.map(link => <li key={link.path} data-id="element-129" data-mp="tcund6yywusx">
                    <SiteLink path={link.path} onClick={onNavigate} className="flex min-h-[52px] items-center justify-between gap-4 py-3 text-label font-semibold text-ink hover:text-crimson" data-id="element-130" data-mp="ocq4xbei1q02">
                      <span data-id="element-131" data-mp="1ztzpk19d6o2y">{link.label}</span>
                      <ArrowRightIcon aria-hidden="true" className="h-5 w-5 shrink-0 text-slate" data-id="element-132" data-mp="xd5vw5o6iymg" />
                    </SiteLink>
                  </li>)}
              </ul>
            </details>)}
        </div>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row" data-id="element-133" data-mp="16d2naf1yebl7">
          <SiteLink path="/#case-review" onClick={onNavigate} className={actionClass("call", "w-full sm:w-auto")} data-id="element-134" data-mp="1bcp2uv5983x6">
            Free Case Review
          </SiteLink>
          <a href={firm.phoneHref} className={actionClass("call", "w-full sm:w-auto")} data-id="element-135" data-mp="iot7puvc2k2i">
            <PhoneIcon aria-hidden="true" className="h-5 w-5" data-id="element-136" data-mp="nonwnsvjszkx" />
            Call {firm.phoneDisplay}
          </a>
        </div>
      </nav>
    </div>;
}